import { connect } from 'react-redux'
import { searchBuilding } from 'Modules/algoliaBuilding/actions'

import BuildingAutoComplete from './BuildingAutoComplete'

const mapStateToProps = state => ({
  results: state.algoliaBuildingList.buildingList,
})
const actions = {
  loadAutoComplete: searchBuilding,
  typingStart: () => ({ type: '' }),
}

export default connect(mapStateToProps, actions)(BuildingAutoComplete)
